const EstadosSiNo = {
    SI: { valor: true, descripcion: "SI" },
    NO: { valor: false, descripcion: "NO" },
  };
  
  export default EstadosSiNo;